


<template>
  <CHeader>
    <div class="container">
      <div class="row">
        <div class="col-sm-1 text-left">
            <CToggler
              in-header
              class="ml-3 d-lg-none"
              @click="$store.commit('toggleSidebarMobile')"
            />
            <CToggler
              in-header
              class="ml-3 d-md-down-none"
              @click="$store.commit('toggleSidebarDesktop')"
            />
        </div>


        <div v-if="userLoggedIn == true" class="col-sm-8 text-left">
            User: {{userName}}
            <br>
            <a href='#' v-on:click='logOut()'>Logout</a>
        </div>
        <div v-else class="col-sm-8 text-left">
            User not logged in.
            <br>
            <router-link to="/auth/signin">Sign in</router-link>
        </div>

        <div class="col-sm-3 text-right">
            {{this.$store.state.orgName}}
            <img src="/SLp_64x64.png" class="img-fluid" alt="Responsive image">
        </div>

        <!-- <div v-if="userLoggedIn == true" class="col-sm-9 text-right">
            User: {{userName}}
            <br>
            <a href='#' v-on:click='logOut()'>Logout</a>
        </div>
        <div v-else class="col-sm text-right">
            User not logged in.
            <br>
            <router-link to="/auth/signin">Sign in</router-link>
        </div> -->


      </div>
    </div>
  </CHeader>
</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import { CHeader } from '@coreui/vue'

export default {
  name: 'TheHeader',

  components: {
    // TheHeaderDropdownAccnt,
  },

  data () {
    return {
      userLoggedIn: false,
      userName: '',
      orgName: '',
    }
  },

  beforeMount: function () {
  },

  mounted () {
    var self = this

    self.refreshHeader()

    // 'refreshHeader' : Triggered by - Signin page
    this.bus.$on('refreshHeader', () => {
      self.refreshHeader()
    })
  },

  methods: {
    refreshHeader () {
      var self = this

      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          self.userLoggedIn = true
          self.userName = user.email
        } else {
          self.userLoggedIn = false
          self.userName = ''
          // Clear User Profile from Session State
          self.saveUserProfile('', '', false, false, false)
          //self.saveUserProfile('', '', '', '', '', false, false, false, false, false, '', false, '')
          // Trigger event to refresh - SideBar
          self.bus.$emit('refreshSidebar')
        }
      })
    },

    logOut () {
      var self = this
      firebase.auth().signOut()
        .then(function () {
          // Clear User Profile from Session State
          self.saveUserProfile('', '', false, false, false)

          self.refreshHeader()
          // Trigger event to refresh - SideBar
          self.bus.$emit('refreshSidebar')

          // Show Home Page
          if (self.$route.name != 'Home') { self.$router.push('/') }
        })
        .catch(function (error) {
          alert('Signout unsuccessful: ' + error)
        })
    }
  }

}
</script>
